(function () {
  'use strict';

  function initReveal() {
    var items = document.querySelectorAll('.bb-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index * 70, 420) + 'ms';
      observer.observe(item);
    });
  }

  function initFaq() {
    document.querySelectorAll('.bb-faq__button').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.bb-faq-item');
        if (!item) return;

        var answer = item.querySelector('.bb-faq__answer');
        var isOpen = item.classList.contains('is-open');
        var wrap = item.closest('.bb-faq__wrap');

        if (wrap) {
          wrap.querySelectorAll('.bb-faq-item.is-open').forEach(function (openItem) {
            if (openItem === item) return;
            var openAnswer = openItem.querySelector('.bb-faq__answer');
            openItem.classList.remove('is-open');
            openItem.querySelector('.bb-faq__button').setAttribute('aria-expanded', 'false');
            if (openAnswer) openAnswer.style.maxHeight = '0px';
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          if (answer) answer.style.maxHeight = '0px';
        } else {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }


  function initAnchorButtons() {
    document.querySelectorAll('[data-bb-scroll]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var selector = link.getAttribute('href');
        if (!selector || selector.charAt(0) !== '#') return;
        var target = document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFaq();
    initAnchorButtons();
  });
})();
